// extracted by mini-css-extract-plugin
export default {"toolHeading":"About_toolHeading__MvgSI","toolTitle":"About_toolTitle__4EMBJ","toolVersion":"About_toolVersion__tTgpe","svg":"About_svg__ZTFum"};